/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-17 11:28:35
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-05-02 10:03:54
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHeader/ScrollEffect/index.tsx
 */
import { store } from '@/src/store';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Checkbox, Input } from 'src/components/Antd';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import { Row } from 'src/components/Layouts';
import Switcher from 'src/components/SectionSwitcher';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import ItemWrapper from 'src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from 'src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import {
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getScrollEffect,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onFixedFieldChange,
  resetConfig,
} from '../slice';
import {
  SalesChannelEditorHeaderEnum,
  errKey,
  filter,
  scrollEffectValidation,
} from '../tool';
function ScrollEffect(props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [s, setS] = useState('logoBarColor');
  const { data, specificError } = props;
  const _d = useDispatch();
  return (
    <React.Fragment>
      <Section bottomBorder style={{ paddingBottom: '24px' }}>
        <Checkbox
          onChange={(checked) => {
            _d(
              onFixedFieldChange({
                path: 'scrollEffect.enabled',
                value: checked,
              }),
            );
          }}
          checked={data.enabled}>
          {getI18n('salesChannelContent.index.enablescrolleffect')}
        </Checkbox>
      </Section>
      {data.enabled && (
        <>
          <Section bottomBorder>
            <ItemWrapper
              title={getI18n('salesChannelContent.index.logoHeight')}>
              <Input
                suffix={'px'}
                size={'large'}
                customFilter={filter}
                error={
                  specificError[errKey.logoHeight] &&
                  specificError[errKey.logoHeight].length !== 0
                }
                help={specificError[errKey.logoHeight]?.join('')}
                value={data.logoHeight}
                onChange={(v) => {
                  _d(
                    onFixedFieldChange({
                      path: 'scrollEffect.logoHeight',
                      value: v,
                    }),
                  );
                }}
              />
            </ItemWrapper>
            <Row
              elements={[
                {
                  child: (
                    <ItemWrapper title={getI18n('general.topPadding')}>
                      <Input
                        suffix={'px'}
                        size={'large'}
                        customFilter={filter}
                        value={data.topPadding}
                        error={
                          specificError[errKey.topPadding] &&
                          specificError[errKey.topPadding].length !== 0
                        }
                        help={specificError[errKey.topPadding]?.join('')}
                        onChange={(v) => {
                          _d(
                            onFixedFieldChange({
                              path: 'scrollEffect.topPadding',
                              value: v,
                            }),
                          );
                        }}
                      />
                    </ItemWrapper>
                  ),
                },
                {
                  child: (
                    <ItemWrapper title={getI18n('general.bottomPadding')}>
                      <Input
                        suffix={'px'}
                        size={'large'}
                        customFilter={filter}
                        error={
                          specificError[errKey.bottomPadding] &&
                          specificError[errKey.bottomPadding].length !== 0
                        }
                        help={specificError[errKey.bottomPadding]?.join('')}
                        value={data.bottomPadding}
                        onChange={(v) => {
                          _d(
                            onFixedFieldChange({
                              path: 'scrollEffect.bottomPadding',
                              value: v,
                            }),
                          );
                        }}
                      />
                    </ItemWrapper>
                  ),
                },
              ]}
            />
          </Section>
          <Section bottomBorder>
            <Switcher
              selected={s}
              onChange={(v) => setS(v)}
              allSections={{
                logoBarColor: {
                  title: getI18n('salesChannelContent.index.logoBarColour'),
                  hasError: false,
                  child: (
                    <React.Fragment>
                      <ItemWrapper title={getI18n('general.backgroundColour')}>
                        <ColorPicker
                          multi
                          onChange={(v) => {
                            _d(
                              onFixedFieldChange({
                                path: 'scrollEffect.logoBarColor.backgroundColor',
                                value: v,
                              }),
                            );
                          }}
                          color={data?.logoBarColor?.backgroundColor}
                        />
                      </ItemWrapper>
                      <ItemWrapper
                        title={getI18n(
                          'salesChannelContent.index.textIconColour',
                        )}>
                        <ColorPicker
                          multi
                          onChange={(v) => {
                            _d(
                              onFixedFieldChange({
                                path: 'scrollEffect.logoBarColor.textColor',
                                value: v,
                              }),
                            );
                          }}
                          color={data?.logoBarColor?.textColor}
                        />
                      </ItemWrapper>
                      <ItemWrapper
                        title={getI18n(
                          'salesChannelContent.index.dividerColour',
                        )}>
                        <ColorPicker
                          multi
                          onChange={(v) => {
                            _d(
                              onFixedFieldChange({
                                path: 'scrollEffect.logoBarColor.dividerColor',
                                value: v,
                              }),
                            );
                          }}
                          color={data?.logoBarColor?.dividerColor}
                        />
                      </ItemWrapper>
                      <ItemWrapper
                        title={getI18n(
                          'salesChannelContent.index.languageSelectorOutlineColour',
                        )}>
                        <ColorPicker
                          multi
                          onChange={(v) => {
                            _d(
                              onFixedFieldChange({
                                path: 'scrollEffect.logoBarColor.outlineColor',
                                value: v,
                              }),
                            );
                          }}
                          color={data?.logoBarColor?.outlineColor}
                        />
                      </ItemWrapper>
                    </React.Fragment>
                  ),
                },
                menuBarColor: {
                  title: getI18n('salesChannelContent.index.menuBarColour'),
                  hasError: false,
                  child: (
                    <React.Fragment>
                      <ItemWrapper title={getI18n('general.backgroundColour')}>
                        <ColorPicker
                          multi
                          onChange={(v) => {
                            _d(
                              onFixedFieldChange({
                                path: 'scrollEffect.menuBarColor.backgroundColor',
                                value: v,
                              }),
                            );
                          }}
                          color={data?.menuBarColor?.backgroundColor}
                        />
                      </ItemWrapper>
                      <ItemWrapper title={getI18n('general.textColour')}>
                        <ColorPicker
                          multi
                          onChange={(v) => {
                            _d(
                              onFixedFieldChange({
                                path: 'scrollEffect.menuBarColor.textColor',
                                value: v,
                              }),
                            );
                          }}
                          color={data?.menuBarColor?.textColor}
                        />
                      </ItemWrapper>
                      <ItemWrapper
                        title={getI18n(
                          'salesChannelContent.index.searchBarOutlineColour',
                        )}>
                        <ColorPicker
                          multi
                          onChange={(v) => {
                            _d(
                              onFixedFieldChange({
                                path: 'scrollEffect.menuBarColor.outlineColor',
                                value: v,
                              }),
                            );
                          }}
                          color={data?.menuBarColor?.outlineColor}
                        />
                      </ItemWrapper>
                    </React.Fragment>
                  ),
                },
              }}
            />
          </Section>
        </>
      )}
    </React.Fragment>
  );
}

export default (props) =>
  ErrorProcessingHOC(ScrollEffect, {
    getCollapseOpenStatus,
    onCollapseOpen,
    expandOffset: props.isResponsive ? 0 : undefined,
    id: SalesChannelEditorHeaderEnum.scrollEffect,
    getContent: getScrollEffect,
    title: getI18nFromGeneral('general.hOCTitle.scrollEffect'),
    getErrorDisplay: getCollapseValidationMsgDisplay,
    onErrorChange,
    getSubmitStamp,
    validation: (x) => {
      return scrollEffectValidation(x);
    },
    headerProps: {
      dotsFunction: [
        {
          onClick: () => {
            store.dispatch(resetConfig({ key: 'scrollEffect' }));
          },
          key: 'Reset Style',
          body: getI18nFromGeneral('general.hOCTitle.resetStyle'),
          isDangerous: true,
        },
      ],
      hasDots: true,
      hideDotsWhenNotPrimary: true,
    },
  })(props);
